import React from 'react';
import { PositionFilter, StrategyVersionFilter, POSITION_SIDE } from '@/services/enums';

type DirectionFilter = PositionFilter;
type TypeFilter = StrategyVersionFilter;

interface FilterBarProps {
  symbolFilter: string;
  onSymbolFilterChange: (value: string) => void;
  onSymbolSearch: () => void;
  selectedDirection: DirectionFilter;
  onDirectionChange: (value: DirectionFilter) => void;
  selectedType: TypeFilter;
  onTypeChange: (value: TypeFilter) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  symbolFilter,
  onSymbolFilterChange,
  onSymbolSearch,
  selectedDirection,
  onDirectionChange,
  selectedType,
  onTypeChange,
}) => {
  return (
    <div
      className="fixed left-0 right-0 z-40 bg-black/10 backdrop-blur-sm border-b border-white/10 px-4 py-2 space-y-2"
      style={{ top: '56px' }}
    >
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={symbolFilter}
          onChange={(e) => onSymbolFilterChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onSymbolSearch();
            }
          }}
          placeholder="币种筛选"
          className="w-24 bg-white/10 border border-white/20 rounded-lg px-3 py-1.5 text-white text-sm placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-white/30"
        />
        <select
          value={selectedDirection}
          onChange={(e) => onDirectionChange(e.target.value as DirectionFilter)}
          className="flex-1 px-3 py-1.5 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:border-white/40"
        >
          <option value="all" className="bg-gray-800 text-white">
            全部方向
          </option>
          <option value={POSITION_SIDE.LONG} className="bg-gray-800 text-white">
            做多
          </option>
          <option value={POSITION_SIDE.SHORT} className="bg-gray-800 text-white">
            做空
          </option>
        </select>
        <select
          value={selectedType}
          onChange={(e) => onTypeChange(e.target.value as TypeFilter)}
          className="flex-1 px-3 py-1.5 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:border-white/40"
        >
          <option value="all" className="bg-gray-800 text-white">
            全部类型
          </option>
          <option value="2" className="bg-gray-800 text-white">
            完全平仓
          </option>
          <option value="3" className="bg-gray-800 text-white">
            强平
          </option>
        </select>
      </div>
    </div>
  );
};

export default FilterBar;
